// Private lessons are one-off, one-on-one sessions with no fixed day, date or time.
// They are stored on the program document as:
//   scheduling_mode: 'by_appointment'
//   private_session_options: [{ label, price }]
//   availability_note: string

export const DEFAULT_PRIVATE_SESSION_OPTIONS = [
  { label: '1 hour', price: 60 },
  { label: '2 hours', price: 110 },
];

export const DEFAULT_AVAILABILITY_NOTE =
  'Scheduled directly with the instructor — weekday afternoons and weekends are usually available.';

export const isPrivateLesson = (program) => program?.scheduling_mode === 'by_appointment';

export const getSessionOptions = (program) => {
  const opts = program?.private_session_options;
  const valid = Array.isArray(opts)
    ? opts.filter(o => o && String(o.label || '').trim() !== '')
    : [];
  return valid.length ? valid : DEFAULT_PRIVATE_SESSION_OPTIONS;
};

export const getLowestSessionPrice = (program) =>
  Math.min(...getSessionOptions(program).map(o => Number(o.price) || 0));
